<template>
  <div class="tab_content">
    <p class="tab_title">附件上传</p>
    <div class="tab_form">
      <el-form ref="form" :model="form" label-width="280px">

        <el-form-item
          v-for="field in normalFields"
          :key="field.key"
          :label="field.label"
          :prop="field.key"
          :rules="field.required ? [{ required: true, message: '请上传' + field.label, trigger: 'change' }] : []"
        >
          <el-upload
            :action="burl + '/api/v1/upload'"
            :file-list="fileLists[field.key]"
            :on-success="(res, file) => handleSuccess(field.key, res)"
            :before-remove="(file) => handleRemove(field.key, file)"
            :on-preview="previewFile"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>

        <!-- 开放许可附件 -->
        <template v-if="isOpenLicense">
          <p class="section-title">开放许可材料</p>
          <el-form-item
            v-for="field in openLicenseFields"
            :key="field.key"
            :label="field.label"
            :prop="field.key"
            :rules="field.required ? [{ required: true, message: '请上传' + field.label, trigger: 'change' }] : []"
          >
            <el-upload
              :action="burl + '/api/v1/upload'"
              :file-list="fileLists[field.key]"
              :on-success="(res, file) => handleSuccess(field.key, res)"
              :before-remove="(file) => handleRemove(field.key, file)"
              :on-preview="previewFile"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </template>

        <div class="button flex-center">
          <el-button type="primary" @click="$emit('aChange', 'tab5')">上一步</el-button>
          <el-button type="primary" @click="doStaging">暂存</el-button>
          <el-button type="primary" @click="doSubmit">下一步</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { baseUrl } from "../../../api/constant";

const ALL_FIELDS = [
  "intentPublishApplication",
  "qualificationDocuments",
  "otherDocuments",
  "releaseAttachment",
  "transferorQualification",
  "otherFiles",
  "openLicenseDeclaration",
  "patentOpenLicenseApproval",
  "serviceFeeApproval",
];

function emptyFileLists() {
  const obj = {};
  ALL_FIELDS.forEach((f) => (obj[f] = []));
  return obj;
}

export default {
  props: ["id", "cfrom"],
  computed: {
    burl() {
      return baseUrl;
    },
    isOpenLicense() {
      return this.cfrom && this.cfrom.licenseType === "开放许可";
    },
    normalFields() {
      return [
        { key: "intentPublishApplication", label: "意向发布申请书", required: false },
        { key: "qualificationDocuments", label: "资质文件", required: false },
        { key: "otherDocuments", label: "其他", required: false },
        { key: "releaseAttachment", label: "发布附件", required: false },
      ];
    },
    openLicenseFields() {
      return [
        { key: "openLicenseDeclaration", label: "开放许可声明/申请表", required: false },
        { key: "patentOpenLicenseApproval", label: "国家局专利开放许可声明准予公告通知书", required: false },
        { key: "serviceFeeApproval", label: "服务费优惠审批单", required: false },
        { key: "transferorQualification", label: "出让方资质文件", required: false },
        { key: "otherFiles", label: "有必要提供的其他文件", required: false },
      ];
    },
  },
  data() {
    return {
      form: {},
      fileLists: emptyFileLists(),
      uploadInfo: {},
    };
  },
  methods: {
    previewFile(file) {
      window.open(file.response && file.response.data ? file.response.data.webPath : file.url);
    },
    handleSuccess(field, res) {
      const url = res.data.webPath;
      const name = res.data.uploadFileName;
      this.fileLists[field] = [...this.fileLists[field], { name, url, status: "success" }];
      this.uploadInfo[field] = this.fileLists[field].map((f) => f.url).join(",");
      this.$set(this.form, field, this.uploadInfo[field]);
    },
    handleRemove(field, file) {
      const url = (file.response && file.response.data) ? file.response.data.webPath : file.url;
      this.fileLists[field] = this.fileLists[field].filter((f) => f.url !== url);
      this.uploadInfo[field] = this.fileLists[field].map((f) => f.url).join(",");
      this.$set(this.form, field, this.uploadInfo[field] || "");
      return true;
    },
    buildValue() {
      const value = { uploadInfo: { ...this.uploadInfo } };
      if (this.id) value.id = this.id;
      return value;
    },
    doStaging() {
      this.$emit("aStagin", this.buildValue());
    },
    doSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit("aChange", "tab7", this.buildValue());
        }
      });
    },
    loadFromCfrom() {
      if (!this.cfrom || !this.cfrom.uploadInfo) return;
      const ui = this.cfrom.uploadInfo;
      ALL_FIELDS.forEach((field) => {
        if (ui[field]) {
          this.uploadInfo[field] = ui[field];
          this.$set(this.form, field, ui[field]);
          this.fileLists[field] = ui[field]
            .split(",")
            .filter(Boolean)
            .map((url) => ({
              name: url.split("/").pop(),
              url,
              status: "success",
            }));
        }
      });
    },
  },
  watch: {
    cfrom() {
      if (!this.cfrom || !this.cfrom.id) return;
      this.loadFromCfrom();
    },
  },
};
</script>

<style lang="scss" scoped>
.tab_content {
  margin: 0 30px;
  .tab_title {
    font-size: 18px;
    font-weight: 500;
  }
  .tab_form {
    margin-top: 20px;
    .section-title {
      font-size: 15px;
      font-weight: 500;
      color: #303133;
      margin: 20px 0 12px;
      padding-left: 10px;
      border-left: 3px solid #409eff;
    }
    .button {
      button {
        width: 160px;
        margin: 0 24px;
        display: block;
      }
    }
  }
}
</style>
